// customers-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'cus.row.noOpenAlerts': 'Ingen åpne varsler',
  'cus.row.openPage': 'Åpne side',
  'cus.row.openTasks': 'Åpne oppgaver',
  'cus.row.noOpenTasks': 'Ingen åpne oppgaver',
  'cus.row.openDeviations': 'Åpne avvik',
  'cus.row.waitingForClient': 'Venter på klienten',
  'cus.row.upcomingDeadlines': 'Kommende frister',
  'cus.row.noNearDeadlines': 'Ingen nære frister',
  'cus.row.lastActivity': 'Siste aktivitet',
  'cus.row.savedInAccounts': 'lagret i regnskapet',
  'cus.row.noActivity': 'Ingen aktivitet registrert',
  'cus.row.shortcuts': 'Snarveier',
  'cus.row.openTheClient': 'Åpne klienten',
  'cus.row.aiAccountant': 'AI Regnskapsfører',
  'cus.row.disciplines': 'Fagområder',
  'cus.row.openChatWith': 'Åpne chat med {name} – {status}',
  'cus.row.hideDetailsFor': 'Skjul detaljer for {name}',
  'cus.row.showDetailsFor': 'Vis detaljer for {name}',
  'cus.row.orgNumber': 'Org. {org}',
  'cus.row.noOrgNumber': 'Uten org.nr.',
  'cus.row.noResponsible': 'Ingen ansvarlig',
  'cus.row.chatWith': 'Chat med {name}',
  'cus.row.chat': 'Chat',
  'cus.row.openClient': 'Åpne klient',
  'cus.row.collapse': 'Skjul {name}',
  'cus.row.showMoreAbout': 'Vis mer om {name}',
  'cus.merge.headline': 'Har du opprettet samme kunde to ganger?',
  'cus.merge.help': 'Velg duplikatet. Fakturaer flyttes til kunden som beholdes, og den andre kunden fjernes.',
  'cus.merge.whichSame': 'Hvilken kunde er det samme som {name}?',
  'cus.merge.selectCustomer': 'Velg kunde...',
  'cus.address.searching': 'Søker i offisielle adresser...',
  'cus.chat.loadFailed': 'Kunne ikke laste kundedialogen.',
  'cus.chat.notConnected': 'Kundedialog er ikke koblet til backend.',
  'cus.chat.newStarted': 'Ny samtale startet {date}',
  'cus.chat.newFailed': 'Kunne ikke starte ny samtale.',
  'cus.chat.quoteBasisFailed': 'Kunne ikke lagre tilbudsgrunnlag.',
  'cus.chat.offerCreated': 'Tilbudsutkast opprettet for {name}',
  'cus.chat.offerFailed': 'Kunne ikke opprette tilbud.',
  'cus.chat.savedInDialog': 'Melding lagret i dialogen',
  'cus.chat.customerMessageSaved': 'Kundemelding lagret',
  'cus.chat.internalNoteSaved': 'Internt notat lagret',
  'cus.chat.saveFailed': 'Kunne ikke lagre meldingen.',
  'cus.chat.sent': 'Melding sendt til kunden',
  'cus.chat.sendFailed': 'Kunne ikke lagre eller sende meldingen.',
  'cus.chat.modalTitle': 'Samtale - {name}',
  'cus.chat.dialogN': 'Dialog {n} · {date}',
  'cus.chat.newConversation': 'Ny samtale ({date})',
  'cus.chat.readyForQuote': 'Klar til tilbud',
  'cus.chat.chipDialog': 'Kundedialog',
  'cus.chat.noMessages': 'Ingen meldinger i denne visningen.',
  'cus.chat.sumExVat': 'Sum eks. mva',
  'cus.chat.vat25': 'Mva (25 %)',
});
